var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.178223,
    width: 44.1782,
    height: 44.1782,
    rx: 22.0891,
    fill: "#0196B1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11030_29213)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.8712 12.9663H18.3044C17.3472 12.9676 16.5716 13.7432 16.5703 14.7004V29.834C16.5716 30.7912 17.3472 31.5668 18.3044 31.5681H25.8712C26.8284 31.5668 27.604 30.7912 27.6053 29.834V14.7004C27.604 13.7432 26.8284 12.9676 25.8712 12.9663ZM26.6594 29.834C26.6588 30.2691 26.3063 30.6216 25.8712 30.6222H18.3044C17.8693 30.6216 17.5168 30.2691 17.5162 29.834V14.7004C17.5168 14.2653 17.8693 13.9128 18.3044 13.9122H25.8712C26.3063 13.9128 26.6588 14.2653 26.6594 14.7004V29.834ZM23.3489 28.4152H20.8266C20.5656 28.4152 20.3537 28.6271 20.3537 28.8881C20.3537 29.1492 20.5656 29.3611 20.8266 29.3611H23.3489C23.61 29.3611 23.8218 29.1492 23.8218 28.8881C23.8218 28.6271 23.61 28.4152 23.3489 28.4152Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11030_29213"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.1782,
    height: 20.1782,
    fill: "white",
    transform: "translate(12 12.1782)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.c486ac5d966e0aaa13f91d712d4bd0e0.svg";
export { ForwardRef as ReactComponent };